import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";
import TutorLayout from "./TutorLayout";

function ReviewHomeworkPage() {
  const [params] = useSearchParams();
  const studentUID = params.get("student");
  const assignmentID = params.get("assignment");

  const [assignment, setAssignment] = useState(null);
  const [progress, setProgress] = useState(null);
  const [studentInfo, setStudentInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (!studentUID || !assignmentID) return;

      try {
        const assignmentSnap = await getDoc(doc(db, "assignments", assignmentID));
        const progressSnap = await getDoc(doc(db, "assignmentProgress", `${assignmentID}_${studentUID}`));
        const studentSnap = await getDoc(doc(db, "users", studentUID));

        if (assignmentSnap.exists()) {
          setAssignment(assignmentSnap.data());
        }
        if (progressSnap.exists()) {
          setProgress(progressSnap.data());
        }
        if (studentSnap.exists()) {
          setStudentInfo(studentSnap.data());
        }

        setLoading(false);
      } catch (err) {
        console.error("Error loading homework:", err);
        setLoading(false);
      }
    };

    fetchData();
  }, [studentUID, assignmentID]);

  if (loading) return <TutorLayout><p>Loading...</p></TutorLayout>;

  if (!assignment || !progress || !studentInfo) {
    return (
      <TutorLayout>
        <h2>🚫 Invalid data</h2>
        <p>Make sure the assignment and student exist.</p>
      </TutorLayout>
    );
  }

  return (
    <TutorLayout>
      <div style={{ padding: "2rem", fontFamily: "Poppins, sans-serif" }}>
        <h2>📄 Review Homework</h2>
        <h3>{assignment.title}</h3>
        <p><strong>Student:</strong> {studentInfo.displayName || studentInfo.email}</p>
        <p><strong>Status:</strong> {progress.handedIn ? "📤 Handed In" : "⏳ Not Handed In"}</p>

        {/* You can expand this section with question review, answers, marking UI etc */}
        <p><strong>Started:</strong> {progress.started ? "✅" : "❌"}</p>
        <p><strong>Completed:</strong> {progress.completed ? "✅" : "❌"}</p>
        <p><strong>Marked:</strong> {progress.marked ? "✅" : "❌"}</p>
      </div>
    </TutorLayout>
  );
}

export default ReviewHomeworkPage;
